export enum RestrictionTransitionEnum {
    REQ_UNKNOWN = 'REQ_UNKNOWN',
    REQ_CREATION = 'REQ_CREATION',
    REQ_REMOVE = 'REQ_REMOVE',
    REQ_CONFIRM = "REQ_CONFIRM",
    REQ_ADDNOTE = 'REQ_ADDNOTE',
    REQ_ACCEPT = 'REQ_ACCEPT',
    REQ_APPROVE = 'REQ_APPROVE',
    REQ_BLOCK = 'REQ_BLOCK'
}